import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles";

import { OptionEnum, OptionModeEnum, OptionTypeEnum } from "../index";

type WrapperProps = IThemeProps<{
  clickable: boolean;
}>;

export const Wrapper = styled.div<WrapperProps>`
  cursor: ${(props: WrapperProps) => (props.clickable ? "pointer" : "default")};
  border-radius: ${(props: WrapperProps) =>
    props.theme.borders.answerTileRadius};
  box-shadow: ${(props: WrapperProps) => props.theme.shadows.s100};
  overflow: hidden;

  ${(props: WrapperProps) =>
    props.clickable &&
    props.theme.thesis.hasAnswerColorEffect &&
    `&:hover {
            span {
                color: ${props.theme.colors.primary} !important;
            }
        }`}
`;

type FlexboxProps = IThemeProps<{
  answer?: OptionEnum;
  mode: OptionModeEnum;
  clickable: boolean;
}>;

export const Flexbox = styled.div<FlexboxProps>`
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: ${(props: FlexboxProps) => {
      return props.answer && props.mode === OptionModeEnum.results
        ? props.theme.colors.pollAndQuizOptionBackgroundModeResult
        : props.theme.colors.pollAndQuizOptionBackground;
    }};
    transition: all 350ms ease-in-out;
    ${(props: FlexboxProps) => {
      if (props.clickable && props.theme.thesis.hasAnswerColorEffect) {
        return `&:hover { background-color:${props.theme.colors.tertiary100}; }`;
      } else if (props.clickable && !props.theme.globals.isTouch) {
        return `&:hover { background-color:${props.theme.colors.pollAndQuizOptionBackgroundModeResult}; }`;
      } else {
        return "";
      }
    }}
    @media ${(props: FlexboxProps) => props.theme.breakpoints.mobile} {
        height: auto;
        min-height: 40px;
    }
`;

type TextProps = IThemeProps<{
  type: OptionTypeEnum;
  mode: OptionModeEnum;
  answer?: OptionEnum;
}>;

export const Text = styled.span<TextProps>`
  font-size: ${(props: TextProps) => props.theme.typography.h200};
  font-weight: 600;
  text-align: center;
  margin: 0 10px;
  transition: color 350ms ease-in-out;
  ${(props: TextProps) => props.type === OptionTypeEnum.poll && PollText}
  ${(props: TextProps) => props.type === OptionTypeEnum.quiz && QuizText}
`;

const PollText = css`
  color: ${(props: TextProps) => {
    const { secondary, fontText } = props.theme.colors;
    let color = fontText;
    if (
      props.mode === OptionModeEnum.results &&
      props.answer &&
      props.answer === OptionEnum.vote
    ) {
      color = secondary;
    }
    return color;
  }};
`;

const QuizText = css`
  color: ${(props: TextProps) => {
    switch (props.answer) {
      case OptionEnum.correct:
        return props.theme.colors.success;
      case OptionEnum.wrong:
        return props.theme.colors.error;
      default:
        return props.theme.colors.fontText;
    }
  }};
`;
